import { PageContainer } from '@components';
import { Projects } from '@views/Projects';
import { store } from '@store';
import { useEffect } from 'react';

const ProjectsPage = () => {
  const projectsFiltered = store.use.projectsFiltered();
  const getProjectsAction = store.use.getProjectsAction().call;
  const isLoadingGetProjectsAvailableAction = store.use.getProjectsAction().status === 'LOADING';

  useEffect(() => {
    getProjectsAction({ model: {} });
  }, []);

  return (
    <PageContainer>
      <Projects
        projectsAvailable={projectsFiltered}
        isLoading={isLoadingGetProjectsAvailableAction}
      />
    </PageContainer>
  );
};

export default ProjectsPage;
